import { h } from 'preact';
import * as actions from 'store/actions';

let staticRender;
// staticRender = (props) => (
// 	<div>
// 		<script type="text/javascript" src="https://fast.fonts.net/jsapi/f9f07630-ccfa-4f09-b448-4a832dadeb2a.js"></script>
// 	</div>
// );

let storeListeners = {};
// storeListeners[actions.TICKET_LINK_CLICKED] = (screening, theater, ev, provider) => {
//
// };

export const disabledLevels = {
	// base: true,
	// studio: true,
	// studioRegion: true,
	// title: true,
};

export {
	// staticRender,
	storeListeners
};
